var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86759 4.63008C3.34947 4.8046 3 5.29459 3 5.84649V9.34829C3 14.9048 6.37552 19.8913 11.5001 21.9052C11.8216 22.0316 12.1784 22.0316 12.4999 21.9052C17.6245 19.8913 21 14.9048 21 9.34829V5.84649C21 5.29459 20.6505 4.80461 20.1324 4.63008L12.6325 2.10372C12.2219 1.96543 11.7781 1.96543 11.3675 2.10372L3.86759 4.63008ZM13.7143 14.0076C13.7143 14.3593 13.4268 14.6445 13.0722 14.6445H10.9278C10.5732 14.6445 10.2857 14.3593 10.2857 14.0076C10.2857 13.5088 9.98026 13.0703 9.57476 12.7753C8.61757 12.079 8 10.9803 8 9.7442C8 7.63927 9.79086 5.93288 12 5.93288C14.2091 5.93288 16 7.63927 16 9.7442C16 10.9803 15.3824 12.079 14.4252 12.7753C14.0197 13.0703 13.7143 13.5088 13.7143 14.0076ZM10.1574 16.3548C10.1574 15.9714 10.4707 15.6607 10.8571 15.6607H13.1429C13.5293 15.6607 13.8426 15.9714 13.8426 16.3548C13.8426 16.7382 13.5293 17.0489 13.1429 17.0489H10.8571C10.4707 17.0489 10.1574 16.7382 10.1574 16.3548Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaShield);
export default __webpack_public_path__ + "static/media/idea-shield.af9a8ba4faf4aed477f52fbada31252b.svg";
export { ForwardRef as ReactComponent };